<template>
  <div>
    <div class="text-center"><logo class="logo"/></div>
    <div class="mt-3">
      <template v-if="this.branch == 'new_york'">
        <NyPatronTerms v-if="page == 'patron'"/>
        <SixMonthTerms v-if="page == 'six-month'"/>
        <NyOtherTerms v-else-if="page == 'memberships'"/>
      </template>
      <template v-if="this.branch == 'stockholm'">
        <template  v-if="page == 'memberships'">
          <StoEnDefaultTerms/>
          <div class="mb-5"></div>
          <StoSvDefaultTerms/>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/global/Logo.vue'
import NyPatronTerms from "./terms/nyc/NyPatronTerms";
import NyOtherTerms from "./terms/nyc/NyOtherTerms";
import StoEnDefaultTerms from "./terms/sto/en/StoEnDefaultTerms";
import StoSvDefaultTerms from "./terms/sto/sv/StoSvDefaultTerms";
import SixMonthTerms from './terms/nyc/SixMonthTerms.vue';

export default {
  components: {
    StoSvDefaultTerms,
    StoEnDefaultTerms,
    NyPatronTerms,
    NyOtherTerms,
    Logo,
    SixMonthTerms
},
  methods: {},
  computed: {
    branch() {
      return process.env.FG_APP_BRANCH
    },
    page() {
      return this.$route.params.page
    }
  },
  mounted() {
    let pages
    if (this.branch == "new_york") {
      pages = ["patron", "memberships", "six-month"];
    } else {
      pages = ["memberships"];
    }
    if (!pages.includes(this.page)) {
      this.$router.push({path: '/'})
    }
  }
}
</script>
